import {
  GET_SIGNATORY_INFO,
  GET_SIGNATORY_INFO_SUCCESS,
  GET_SIGNATORY_INFO_FAIL,
  AUTHORIZE_SIGNATORY,
  AUTHORIZE_SIGNATORY_SUCCESS,
  AUTHORIZE_SIGNATORY_FAIL
} from "../actions/getSignatoryInfo";
import { handleActions } from "../../utils/redux-utils";

export const initialState = {
  loading: false,
  signatoryResponse: {},
  authorizeLoading: false
};

export default handleActions(
  {
    [GET_SIGNATORY_INFO]: state => ({
      ...state,
      loading: true,
      signatoryResponse: initialState.signatoryResponse
    }),
    [GET_SIGNATORY_INFO_SUCCESS]: (state, { payload }) => ({
      ...state,
      loading: false,
      signatoryResponse: payload
    }),
    [GET_SIGNATORY_INFO_FAIL]: state => ({
      ...state,
      loading: false,
      signatoryResponse: initialState.signatoryResponse
    }),
    [AUTHORIZE_SIGNATORY]: state => ({
      ...state,
      authorizeLoading: true
    }),
    [AUTHORIZE_SIGNATORY_SUCCESS]: state => ({
      ...state,
      authorizeLoading: false
    }),
    [AUTHORIZE_SIGNATORY_FAIL]: state => ({
      ...state,
      authorizeLoading: false
    })
  },
  initialState
);
